/**
 * Directive permettant d'afficher le patrimoine d'un client.
 */
app.directive('treeViewClientNodes', [ 'crudService', '$filter', 
function(crudService, $filter) 
{
    return {
        restrict: 'E',
        templateUrl: '/templates/partials/directives/ztree-view/patrimoine_client.html',
        scope: {
            clientId: '='
        },
        link: function (scope, element) {

            /**
             * ========================= INITIALISATION =========================
             */
            var that = this;
            this.zTree = null;
            this.nodes = [];


            /**
             * ========================= RECUPERATION DES NOEUDS =========================
             */
            this.loadClientNodes = function(clientId)
            {
                
            };
        }
    }
}]);